"use strict";
/*
 * Copyright 2020 - MATTR Limited
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *     http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertBls12381G2PrivateJwk = exports.assertBls12381G2PublicJwk = void 0;
const JsonWebKey_1 = require("./JsonWebKey");
const types_1 = require("../types");
const assertBls12381G2PublicJwk = (jwk) => {
    // Returns false because the BLS12-381 G2 x coordinate is not the proper length
    return ((0, JsonWebKey_1.assertPublicBlsJwk)(jwk) &&
        (jwk.crv === types_1.BlsCurveName.DEPRECATED_G2 || jwk.crv === types_1.BlsCurveName.G2) &&
        jwk.x.length === 128);
};
exports.assertBls12381G2PublicJwk = assertBls12381G2PublicJwk;
const assertBls12381G2PrivateJwk = (jwk) => {
    // Returns false because the BLS12-381 G2 x coordinate is not the proper length
    return ((0, JsonWebKey_1.assertPrivateBlsJwk)(jwk) &&
        (jwk.crv === types_1.BlsCurveName.DEPRECATED_G2 || jwk.crv === types_1.BlsCurveName.G2) &&
        jwk.x.length === 128);
};
exports.assertBls12381G2PrivateJwk = assertBls12381G2PrivateJwk;
//# sourceMappingURL=Bls12381G2Jwk.js.map